import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NightlifeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"nightlife"}/>
}
